import styles from './bundleOffersView.module.css'
import { useBundles } from 'modules/Bundles/remotes'
import Heading from 'components/Heading'
import Content from 'components/Content'
import LoadingContent from 'components/LoadingContent'
import BundleOfferBrief from 'components/BundleOfferBrief'

const BundlesView = () => {
  const { bundles, isBundlesLoading } = useBundles()
  console.log({ bundles })

  if (isBundlesLoading) {
    return <LoadingContent label={'Loading...'} />
  }
  return <div className={styles.bundlesView}>
    { bundles && <div className={styles.allBundles}>
      <Content width='fullwidth'>
        <div className={styles.heading}>
          <Heading>Prepared Bundles</Heading>
          <p>Get all the cards you need for that special someone. You can buy the collection as is, or customize it to your heart’s content. When you bundle cards with CardHero, you save time and money. Not bad!</p>
          <p>Check out our most popular bundles below.</p>
        </div>
        { bundles.map((bundle) => <BundleOfferBrief bundle={bundle} key={bundle.id} />)}
      </Content>
    </div> }
  </div>
}

export default BundlesView
